import { atom } from 'jotai';

export const TenantId = atom(0);
export const csrfToken = atom<string | null>(null);